import * as React from 'react';
import { withRouter } from 'react-router';
import { Row, Col, Icon, Button, message, Tooltip, Radio, Tag, Dropdown,Menu } from 'antd';
import { MOBILE_BREAK_POINT } from 'src/globals';
import injectSheet from 'react-jss';
import { editBidForInquiryRoute, getInquiryCreateBidRoute } from 'src/routing/utils';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { connect } from 'react-redux';
import BidsDeleteModal from '../Modals/BidsDeleteModal';
import { deleteBidsForInquiry, sendBid, getRank1Price } from 'src/api/inquiry';
import { bindActionCreators } from 'redux';
import { resetFilters, getBidsFF, applyFilter } from 'src/actions/inquiryFFActionBids';
import ViewBreakdown from '../Modals/ViewBreakdown';
import ExtendBidDeadline from '../Modals/ExtendBidDeadline';
import PricePerContainer from '../../../common/PricePerContainer';
import {
  BID_ROUTES_CARD_LABELS,
  getBidTotal,
  InquiryModes,
} from '../../../pages/Enquiry/InquiryUtils';
import CommentCount from '../../../common/comments/CommentCount';
import FrieghtPerUnit from '../../../common/FreightPerUnit';
import BidRevisionModal from '../BidRevisionModal';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import { isValidNumber, getDateValue } from 'src/Library/Helper';
import { getTrailerOrDomesticVehicleList, renderTotalPrice } from './InquiryCommon';
import classNames from 'classnames';
import { commonStyles } from 'src/Library/CommonStyles';
import { DownloadDocument } from 'src/components/common/DownloadDocument';
import FileViewer from 'src/components/common/FileViewer';
import { formatDateFromObject } from 'src/utils/utils';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  parentDiv: {
    '& .ant-btn': {
      boxShadow: '0 0 0 rgba(0,0,0,0) !important',
    },
    minHeight: '132px',
    padding: `${tokens.spacing.md}px 0px 10px 0px`,
    height: '100%',
    background: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    margin: `0 ${tokens.spacing.ms}px ${tokens.spacing.sm}px ${tokens.spacing.ms}px`,
    paddingLeft: `${tokens.spacing.lg}px`,
  },
  titleLabel: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.text,
    lineHeight: '110%',
  },
  cardHeaderItemsStyle: {
    fontSize: `${tokens.fontSize.small}px`,
    marginBottom: '10px',
    color: '#595959',
  },
  info: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.text,
    float: 'right',
    width: '44%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  dateStyle: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.text,
    float: 'right',
    width: '56%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  cardIcon: {
    margin: '0px 0px 0px 2px',
    fontSize: `${tokens.fontSize.h2}px`,
  },
  cardDeleteIcon: {
    padding: '10px',
  },
  cardEditIcon: {
    padding: '10px',
  },
  viewBreakdownStyle: {
    fontSize: `${tokens.fontSize.caption}px`,
    padding: '5px 0px',
    color: tokens.colors.primary,
  },
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    parentDiv: {
      minHeight: '132px',
    },
  },
  card: {},
  deletedIcon: {
    color: '#F5222D',
    fontSize: `${tokens.fontSize.body}px`,
  },
  deleteBidInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    marginLeft: '2px',
  },
  iconToolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  priceSummary: {
    display: 'flex',
    flexDirection: 'column',
  },
  col4: {
    margin: '0px 15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  shippingLineName: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
  },
  versionHistoryButton: {
    marginLeft: 8,
    color: theme.primaryColor,
    cursor: 'pointer',
  },
  renderVersionContainer: {
    display: 'inline-block',
  },
  btmRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
    gap: '8px',
  },
  btmRowLeftSection: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    minWidth: 0,
  },
  updatedTimeContainer: {
    whiteSpace: 'nowrap',
  },
  rank1GapLabel: {
    borderColor: '#F2BF5F',
    fontSize: tokens.fontSize.caption,
    backgroundColor: '#fffdf4',
    cursor: 'auto',
    '&:hover, &:focus': { color: '#6f6e6a' },
  },
  ellipsis: {
    ...commonStyles(theme).ellipses,
  },
  domesticInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    padding: '0px 0px 0px 5px',
  },
  domensticBidInfoRow: {
    marginTop: '16px',
  },
  deletedBidParentDiv: {
    background: '#FFEFEF',
  },
  confirmationReasonButton: {
    borderColor: '#D9D9D9',
    backgroundColor: '#F5F5F5',
    maxWidth: '250px',
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  confirmationReasonIcon: {
    color: '#52C41A',
    marginRight: '4px',
    flexShrink: 0,
  },
  confirmationReasonText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: 1,
  },
});

class BidCard extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      isSent: this.props.cardData.isSent,
      bidsDeleteModalVisible: false,
      isSendBidLoading: false,
      viewBreakdownVisible: false,
      isDeleteLoading: false,
      revisionModalVisible: false,
      isVehicleDetailsExpanded: false,
      fileViewerVisible: false,
      selectedDocument: null,
    };
  }

  infoBidSent = () => {
    message.success('Your bid has been sent.');
  };

  infoFailedToSendBid = (errorMessage) => {
    message.error(errorMessage);
  };

  sendBidData = async () => {
    const { id: bidId, validTill, shipperId } = this.props.cardData;
    const { inquiryId } = this.props;
    const validTillTime = new Date(validTill).getTime();
    const currentTime = new Date().getTime();
    if (currentTime > validTillTime) {
      message.error('Bid Expired');
      sendEvent(EventCategories.INQUIRY_BIDDING, 'Send Bid - Failed (Data Validation)');
      return;
    }
    this.setState({ isSendBidLoading: true });
    await sendBid({ bidId, inquiryId, shipperId }).then((res) => {
      if (res.isSuccess) {
        sendEvent(EventCategories.INQUIRY_BIDDING, 'Send Bid');
        this.infoBidSent();
        this.setState({ isSent: true });
        this.props.getBidsFF(inquiryId);
      } else {
        this.infoFailedToSendBid(res.errorMessage);
        sendEvent(EventCategories.INQUIRY_BIDDING, 'Send Bid - Failed');
      }
    });
    this.setState({ isSendBidLoading: false });
  };

  renderConfirmButton = () => {
    return (
      <Button
        type="primary"
        style={{
          color: '#52C41A',
          margin: '5px 0px',
          borderColor: '#52C41A',
          backgroundColor: tokens.colors.bgWhite,
        }}
        onClick={this.handleEdit}
      >
        Confirm
      </Button>
    );
  };

  renderButton = () => {
    const { id: bidId } = this.props.cardData;
    const { inquiryId, isAddBidCard } = this.props;
    if (isAddBidCard) {
      return null;
    }
    return (
      <Button
        loading={this.state.isSendBidLoading}
        type="primary"
        style={{
          backgroundColor: '#52C41A',
          margin: '5px 0px',
          borderColor: '#52C41A',
        }}
        onClick={this.sendBidData}
      >
        Send Bid
      </Button>
    );
  };

  renderConfirmedStatus = () => {
    return (
      <div>
        <Icon type="check-circle" theme="filled" style={{ color: '#44D13D' }} />
        <span style={{ fontWeight: tokens.fontWeight.semibold, marginLeft: '4px' }}>Bid Confirmed</span>
      </div>
    );
  };

  renderSentStatus = () => {
    return (
      <div>
        <Icon type="check-circle" theme="filled" style={{ color: '#52C41A' }} />
        <span style={{ paddingLeft: '4px' }}>Bid Sent</span>
      </div>
    );
  };

  renderBidSentStatus = () => {
    const { classes, cardData } = this.props;
    return (
      <div style={{ fontSize: `${tokens.fontSize.body}px`, padding: '8px 0px 3px 0px' }}>
        {!cardData.isDeletedByShipper ? (
          cardData.isSent ? (
            cardData.isConfirmed ? (
              this.renderConfirmedStatus()
            ) : (
              this.renderSentStatus()
            )
          ) : null
        ) : (
          <div>
            <span
              style={{ color: '#F5222D', fontSize: `${tokens.fontSize.body}px`, fontWeight: tokens.fontWeight.semibold, paddingRight: '4px' }}
            >
              Bid Deleted
            </span>
            <Tooltip title={cardData.deletionReason}>
              <Icon type="info-circle" theme="filled" className={classes.deleteBidInfo} />
            </Tooltip>
          </div>
        )}
      </div>
    );
  };

  handleEdit = () => {
    const { history, inquiryId } = this.props;
    const bidId = this.props.cardData.id;
    sendEvent(EventCategories.INQUIRY_BIDDING, 'Edit Bid - Click');
    history.push(editBidForInquiryRoute(inquiryId, bidId));
  };

  handleDuplicate = () => {
    const { history, inquiryId } = this.props;
    const bidId = this.props?.cardData?.id;
    if (!bidId) return;
    history.push({
      pathname: getInquiryCreateBidRoute(inquiryId),
      state: { fromBids: 'fromBids', duplicatedBidId: bidId },
    });
  };

  handleDeleteBid = async () => {
    const { id } = this.props.cardData;
    const { inquiryId } = this.props;
    this.setState({ isDeleteLoading: true });
    const response = await deleteBidsForInquiry({ bidId: id });
    if (response.isSuccess) {
      sendEvent(EventCategories.INQUIRY_BIDDING, 'Delete Bid');
      message.success('Bid Deleted');
    } else {
      sendEvent(EventCategories.INQUIRY_BIDDING, 'Delete Bid - Failed');
      message.error('Unable to delete bid');
    }
    this.setState({ isDeleteLoading: false });
    this.props.applyFilter(inquiryId);
  };

  closeViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: false,
    });
  };

  handleExtendDeadline = (type, reload) => {
    this.setState({
      extendDeadlineVisible: type,
    });
    const { inquiryId } = this.props;
    if (reload) {
      this.props.resetFilters(inquiryId);
    }
  };

  handleVehicleListExpand = () => {
    this.setState({
      isVehicleDetailsExpanded: !this.state.isVehicleDetailsExpanded,
    });
  };

 renderDownloadTnCdocs = () => {
  const { cardData } = this.props;
  if (!cardData || !cardData.otherDetails || !cardData.otherDetails.termsAndConditions) return '';
  
  const { otherDetails, mode } = cardData;
  const { termsAndConditions } = otherDetails;
  const isAttachment = mode === InquiryModes.DOMESTIC || mode === InquiryModes.TRAILER || mode === InquiryModes.RPTL;
  const toolTipLabel = isAttachment ? 'Attachment' : 'Terms & Conditions';

  const handleViewDocument = (doc) => {
    this.setState({
      fileViewerVisible: true,
      selectedDocument: {
        url: doc.url,
        name: doc.name,
        type: doc.type || toolTipLabel
      }
    });
  };

  const handleDownloadDocument = (doc, event?) => {
    const link = document.createElement('a');
    link.href = doc.url;
    link.download = doc.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Normalize to array format
  const documentsArray = Array.isArray(termsAndConditions) 
    ? termsAndConditions 
    : [{ url: termsAndConditions.url, name: termsAndConditions.name, type: toolTipLabel }];

  // Single document - show view and download buttons vertically
  if (documentsArray.length === 1) {
    const doc = documentsArray[0];
    
    return (
      <>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          gap: '2px',
          padding: '2px 0'
        }}>
          <Tooltip title={`View ${doc.name}`}>
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
              onClick={() => handleViewDocument(doc)}
            >
              <Icon type="eye" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Tooltip>
          
          <Tooltip title={`Download ${doc.name}`}>
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
              onClick={(event) => handleDownloadDocument(doc)}
            >
              <Icon type="download" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Tooltip>
        </div>
        
        {/* FileViewer for single document */}
        {this.state.fileViewerVisible && this.state.selectedDocument && (
          <FileViewer
            url={this.state.selectedDocument.url}
            title={this.state.selectedDocument.name}
            fileName={this.state.selectedDocument.name}
            onClose={() => this.setState({ fileViewerVisible: false, selectedDocument: null })}
          />
        )}
        <br />
      </>
    );
  }

  // Multiple documents - show view and download buttons vertically with menus
  const viewMenuItems = documentsArray.map((doc, index) => (
    <Menu.Item key={`view-${index}`} onClick={() => handleViewDocument(doc)}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        maxWidth: '200px'
      }}>
        <Icon type="eye" style={{ 
          marginRight: '8px',
          fontSize: `${tokens.fontSize.small}px`,
          color: 'inherit',
          flexShrink: 0
        }} />
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: `${tokens.fontSize.small}px`
          }}
          title={`${doc.type} - ${doc.name}`}
        >
          {`${doc.type} - ${doc.name}`}
        </span>
      </div>
    </Menu.Item>
  ));

  const downloadMenuItems = documentsArray.map((doc, index) => (
    <Menu.Item key={`download-${index}`} onClick={(event) => handleDownloadDocument(doc)}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        maxWidth: '200px'
      }}>
        <Icon type="download" style={{ 
          marginRight: '8px',
          fontSize: `${tokens.fontSize.small}px`,
          color: 'inherit',
          flexShrink: 0
        }} />
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: `${tokens.fontSize.small}px`
          }}
          title={`${doc.type} - ${doc.name}`}
        >
          {`${doc.type} - ${doc.name}`}
        </span>
      </div>
    </Menu.Item>
  ));

  return (
    <>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2px',
        padding: '2px 0'
      }}>
        <Tooltip title="View documents">
          <Dropdown
            overlay={<Menu>{viewMenuItems}</Menu>}
            trigger={['click']}
            placement="bottomLeft"
          >
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
            >
              <Icon type="eye" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Dropdown>
        </Tooltip>

        <Tooltip title="Download documents">
          <Dropdown
            overlay={<Menu>{downloadMenuItems}</Menu>}
            trigger={['click']}
            placement="bottomLeft"
          >
            <Button 
              type="link" 
              size="small"
              style={{ 
                padding: '2px 4px', 
                color: 'inherit',
                minWidth: '24px',
                height: '20px'
              }}
            >
              <Icon type="download" style={{ fontSize: `${tokens.fontSize.small}px` }} />
            </Button>
          </Dropdown>
        </Tooltip>
      </div>
      
      {/* FileViewer for multiple documents */}
      {this.state.fileViewerVisible && this.state.selectedDocument && (
        <FileViewer
          url={this.state.selectedDocument.url}
          title={this.state.selectedDocument.name}
          fileName={this.state.selectedDocument.name}
          onClose={() => this.setState({ fileViewerVisible: false, selectedDocument: null })}
        />
      )}
      <br />
    </>
  );
};

  renderDuplicateIcon = () => {
    const { classes, permission } = this.props;
    return (
      <div className={classes.cardIcon}>
        <Tooltip title="Duplicate" placement="left">
          <Icon type="copy" style={{ cursor: 'pointer' }} onClick={this.handleDuplicate} />
        </Tooltip>
      </div>
    );
  };

  renderIconWithTooltip = (type, title, onClick) => (
    <>
      <Tooltip title={title} placement="left">
        <Icon type={type} style={{ cursor: 'pointer' }} onClick={onClick} />
      </Tooltip>
      <br />
    </>

  );

  renderIcon = () => {
    const { classes, permission, inquiryData, cardData } = this.props;
    const { isSent } = this.state;
    const isNotClosed = inquiryData.status !== 'CLOSED';

    if (this.props.cardData.isConfirmed || !permission) return '';
    if (isSent) {
      return (
        <>
          {this.props.cardData.isDeletedByShipper ? (
            <div className={classes.cardIcon}>
              <Tooltip title="Delete">
                <Icon
                  type="delete"
                  style={{ fontSize: `${tokens.fontSize.h2}px`, cursor: 'pointer' }}
                  onClick={() => this.setState({ bidsDeleteModalVisible: true })}
                />
                <BidsDeleteModal
                  isLoading={this.state.isDeleteLoading}
                  handleOk={this.handleDeleteBid}
                  handleCancel={() => this.setState({ bidsDeleteModalVisible: false })}
                  visible={this.state.bidsDeleteModalVisible}
                />
              </Tooltip>
              <br />
            </div>
          ) : (
            <div>
      <div className={classes.cardIcon}>
        {isNotClosed && (
          <>
            {this.renderIconWithTooltip("copy", "Duplicate", this.handleDuplicate)}
            {this.renderIconWithTooltip("edit", "Edit", this.handleEdit)}
          </>
        )}
        {this.renderIconWithTooltip(
          "calendar", 
          "Extend Bid Validity Date", 
          () => this.handleExtendDeadline(true, false)
        )}
      </div>
    </div>
          )}
        </>
      );
    }
    return (
      <>
        <div className={classes.cardIcon}>
          {isNotClosed && (
          <>
            {this.renderIconWithTooltip("copy", "Duplicate", this.handleDuplicate)}
            {this.renderIconWithTooltip("edit", "Edit", this.handleEdit)}
          </>
        )}
          {this.renderIconWithTooltip(
            "calendar",
            "Extend Bid Validity Date",
            () => this.handleExtendDeadline(true, false)
          )}
        </div>
        <BidsDeleteModal
          isLoading={this.state.isDeleteLoading}
          handleOk={this.handleDeleteBid}
          handleCancel={() => this.setState({ bidsDeleteModalVisible: false })}
          visible={this.state.bidsDeleteModalVisible}
        />
      </>
    );
  };

  renderUpdatedTime = () => {
    const { cardData } = this.props;
    if (!cardData.updatedAt) return null;
    const flag = moment(cardData.updatedAt).format('DD MMM, YYYY | hh:mm A');
    return (
      <div
        style={{
          opacity: 0.7,
          fontSize: '13px',
          fontStyle: 'italic',
          paddingRight: '35px',
        }}
      >
        Updated on: {flag}
      </div>
    );
  };

  priceTotal = (commentTextStyle, amount, currencySymbol) => {
    const { cardData } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: 10, color: '#333', fontSize: commentTextStyle ? 14 : 10 }}>
          Total Price
        </span>
        <span style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.text, fontSize: 14 }}>
          {getBidTotal(amount)} {currencySymbol}
        </span>
      </div>
    );
  };

  showVersionHistory = () => {
    this.setState({
      revisionModalVisible: true,
    });
  };

  getDomesticCharges = (chargeObj, isExchangeDatePresent) => {
    if (!Object.keys(chargeObj || {})?.length) return 0;
    if (isExchangeDatePresent) {
      return `${chargeObj?.userTotalWithoutTax?.amount?.toFixed(2)} ${chargeObj?.userTotalWithoutTax?.currency}`
    } return `${chargeObj?.ffTotalWithoutTax?.amount?.toFixed(2)} ${chargeObj?.ffTotalWithoutTax?.currency}`
  }

  renderModal = () => {
    const { cardData, inquiryData } = this.props;
    const { revisionModalVisible } = this.state;

    return (
      revisionModalVisible && (
        <BidRevisionModal
          visible={revisionModalVisible}
          handleCancel={() => {
            this.setState({
              revisionModalVisible: false,
            });
          }}
          title="Revision History"
          okText="Okay"
          userType="FF"
          handleOk={() => {
            this.setState({
              revisionModalVisible: false,
            });
          }}
          inquiryDetails={inquiryData}
          baseRevisionBidId={cardData.baseRevisionBidId}
          cancelButtonVisible={false}
        />
      )
    );
  };

  renderCol1 = () => {
    const { cardData, classes } = this.props;
    const origin = ` ${cardData.origin?.name ?? ''} (${cardData.origin?.code ?? ''})`;
    const destination = ` ${cardData.destination?.name ?? ''} (${cardData.destination?.code ?? ''})`;
    return (
      <Col span={5}>
        <div style={{ fontSize: `${tokens.fontSize.body}px`, color: '#262626' }}>{cardData.ffCarrierName}</div>
        <div style={{ marginTop: '8px' }}>
          <img src={cardData.carrierLogoUrl} style={{ maxHeight: '40px', maxWidth: '70%' }} />
        </div>
        <div style={{ fontSize: `${tokens.fontSize.h3}px`, color: '#262626', margin: '16px 0px 0px' }}>
          {cardData.rank && `Rank: ${cardData.rank}`}
        </div>
        {cardData.origin && (
          <div>
            Origin: 
            <span>{origin}</span>
          </div>
        )}
        {cardData.destination && (
          <div>
            Destination: 
            <span>{destination}</span>
          </div>
        )}
      </Col>
    );
  };

  renderCol2 = () => {
    const { classes, cardData, currency, timezone } = this.props;
    if (!cardData || !cardData.otherDetails) return '';
    const { otherDetails } = cardData;
    if (cardData.mode === InquiryModes.DOMESTIC || cardData.mode === InquiryModes.RPTL) {
      return this.renderDomesticCol2();
    }
    return (
      <Col span={6}>
        <div>
        {otherDetails?.originFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Origin Free Days
              <span className={classes.info}>{otherDetails?.originFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.demurrageFreeDays &&  (
            <div className={classes.cardHeaderItemsStyle}>
              Demurrage Free Days
              <span className={classes.info}>{otherDetails?.demurrageFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.detentionFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Detention Free Days
              <span className={classes.info}>{otherDetails?.detentionFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.cfsFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              CFS Free Days
              <span className={classes.info}>{otherDetails?.cfsFreeDays ?? '-'}</span>
            </div>
          )}
          {otherDetails?.combinedFreeDays && (
            <div className={classes.cardHeaderItemsStyle}>
              Combined Free Days
              <span className={classes.info}>{otherDetails?.combinedFreeDays ?? '-'}</span>
            </div>
          )}
          {cardData.mode === InquiryModes.TRAILER && (
            <div className={classes.cardHeaderItemsStyle}>
              Detention Cost Per Day
              <span className={classes.info}>
                {isValidNumber(otherDetails?.detentionCostPerDay?.amount)
                  ? `${currency[`${otherDetails?.detentionCostPerDay?.currency}`]}${
                      otherDetails?.detentionCostPerDay?.amount
                    }`
                  : '-'}
              </span>
            </div>
          )}
          <div className={classes.cardHeaderItemsStyle}>
            Route
            <Tooltip
              title={
                otherDetails.route?.length > 1
                  ? otherDetails.route
                      ?.map((item) => BID_ROUTES_CARD_LABELS[item] || item)
                      .join(', ')
                  : ''
              }
            >
              <span className={classNames(classes.info, classes.ellipsis)}>
                {otherDetails.route
                  ?.map((item) => BID_ROUTES_CARD_LABELS[item] || item)
                  .join(', ') || '-'}
              </span>
            </Tooltip>
          </div>
          {otherDetails.transshipmentVia && (
            <div className={classes.cardHeaderItemsStyle}>
              Transshipment
              <span className={classes.info}>
                {otherDetails.transshipmentVia?.length > 0 ? (
                  <Tooltip
                    title={
                      otherDetails.transshipmentVia.length > 1
                        ? otherDetails.transshipmentVia.map((item) => <div>{item.label}</div>)
                        : ''
                    }
                  >
                    <span>
                      {otherDetails.transshipmentVia[0].label}
                      {otherDetails.transshipmentVia.length <= 1
                        ? ''
                        : ` + ${otherDetails.transshipmentVia?.length - 1}`}
                    </span>
                  </Tooltip>
                ) : (
                  '-'
                )}
              </span>
            </div>
          )}
          <div className={classes.cardHeaderItemsStyle}>
            Valid Till
            <span className={classes.info}>
              {cardData && cardData.validTill
                ? momentTimezone(cardData.validTill).tz(timezone).format('DD MMM YYYY')
                : '-'}
            </span>
          </div>
        </div>
      </Col>
    );
  };

  renderCol3 = () => {
    const { classes, cardData } = this.props;
    const { otherDetails } = cardData;
    const alternateVesselSchedule = cardData?.otherDetails?.alternateVesselSchedule || '-';
    const truncatedText = alternateVesselSchedule.length > 10 ? `${alternateVesselSchedule.slice(0, 10)}...` : alternateVesselSchedule || '-';
    if (cardData.mode === InquiryModes.DOMESTIC || cardData.mode === InquiryModes.RPTL) {
      return this.renderDomesticCol3();
    }
    return (
      <Col span={7}>
        <div>
          {(
            <div className={classes.cardHeaderItemsStyle}>
              SI Cut Off{' '}
              <span className={classes.info}>
                {cardData?.otherDetails?.siCutOff ? getDateValue(formatDateFromObject(cardData?.otherDetails?.siCutOff))?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {(
            <div className={classes.cardHeaderItemsStyle}>
              ETD{' '}
              <Tooltip
                title={
                  cardData.mode === InquiryModes.AIRCARGO
                    ? 'Flight Date'
                    : cardData.mode === InquiryModes.DOMESTIC
                    ? 'Departure Date'
                    : 'Sailing Date'
                }
              >
                <Icon type="exclamation-circle" theme="filled" />
              </Tooltip>
              <span className={classes.info}>
                {cardData?.otherDetails?.etd ? getDateValue(cardData?.otherDetails?.etd)?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {(
            <div className={classes.cardHeaderItemsStyle}>
              ETA{' '}
              <span className={classes.info}>
                {cardData?.otherDetails?.eta ? getDateValue(formatDateFromObject(cardData?.otherDetails?.eta))?.format('DD MMM YYYY') : '-'}
              </span>
            </div>
          )}
          {cardData.mode !== InquiryModes.TRAILER && (
            <div className={classes.cardHeaderItemsStyle}>
              Transit Days
              <span className={classes.info}>{otherDetails?.transitDays ?? '-'}</span>
            </div>
          )}
          {cardData.mode === InquiryModes.TRAILER ? (
            <div className={classes.cardHeaderItemsStyle}>
              Round Trip Time
              <span className={classes.info}>
                {isValidNumber(cardData.otherDetails?.roundTripTime?.value)
                  ? `${cardData.otherDetails?.roundTripTime?.value} ${cardData.otherDetails?.roundTripTime?.type}`
                  : '-'}
              </span>
            </div>
          ) : (
            <React.Fragment>
              <div className={classes.cardHeaderItemsStyle}>
                Schedule
                <span className={classes.info}>
                  {cardData &&
                  cardData.otherDetails &&
                  cardData.otherDetails.schedule &&
                  cardData.otherDetails.schedule.length > 0
                    ? cardData.otherDetails.schedule.map((item) => `${item[0].toUpperCase()} `)
                    : '-'}
                </span>
              </div>
            </React.Fragment>
          )}
          {(
            <div className={classes.cardHeaderItemsStyle} title={alternateVesselSchedule}>
              Alternate Vessel Schedule{' '}
              <span className={classes.info}>
                {truncatedText}
              </span>
            </div>
          )}
          {(
            <div className={classes.cardHeaderItemsStyle}>
              Allowed Cargo Weight (Kg) {' '}
              <span className={classes.info}>
                {cardData?.otherDetails?.allowedCargoWeight || '-'}
            </span>
          </div>
        )}
        </div>
      </Col>
    );
  };

  renderCol4 = () => {
    const { classes, cardData, permission, isAddBidCard, inquiryData, currency } = this.props;
    const { isSent } = this.state;
    const { isConfirmationRequiredForNegotiatedBid } = cardData;
    const amount = cardData.ffTotalWithoutTax && cardData.ffTotalWithoutTax.amount;
    const perLabel = cardData.freightPerUnit && cardData.freightPerUnit.format;
    const currencySymbol = cardData?.ffTotalWithoutTax?.currency;
    return (
      <div
        className={`ant-col ant-col-${isAddBidCard ? '5' : '6'}`}
        style={{ paddingRight: '16px' }}
      >
        <Row>
          <Col span={20}>
            <div style={{ marginLeft: '10px' }}>
              <div>
                {this.priceTotal(true, amount, currencySymbol)}
                {![InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL].includes(cardData.mode) ? (
                  <FrieghtPerUnit
                    amount={cardData?.freightPerUnit?.amount}
                    currency={ cardData?.freightPerUnit?.currency}
                    perLabel={perLabel}
                    label={'Avg Freight'}
                  />
                ) : (InquiryModes.DOMESTIC === cardData.mode || InquiryModes.RPTL === cardData.mode) ? (
                  ''
                ) : (
                  renderTotalPrice(cardData.ffTotalWithoutTax, currency)
                )}
                <div className={classes.viewBreakdownStyle}>
                  <a
                    className={classes.viewBreakdownStyle}
                    onClick={() => this.setState({ viewBreakdownVisible: true })}
                  >
                    View Breakdown
                  </a>
                </div>
                {this.state.viewBreakdownVisible && (
                  <ViewBreakdown
                    mode={cardData?.mode}
                    type={'FF'}
                    bidId={cardData.id}
                    inquiryId={this.props.inquiryId}
                    visible={this.state.viewBreakdownVisible}
                    inquiryDetails={inquiryData}
                    handleCancel={this.closeViewBreakdown}
                    handleOk={this.closeViewBreakdown}
                  />
                )}
              </div>
              {isAddBidCard && this.renderDownloadTnCdocs()}
              {isConfirmationRequiredForNegotiatedBid
                ? permission && this.renderConfirmButton()
                : isSent
                ? this.renderBidSentStatus()
                : permission
                ? this.renderButton()
                : ''}
            </div>
          </Col>
          {!isAddBidCard && this.renderCol5()}
        </Row>
      </div>
    );
  };

  renderCol5 = () => {
    const { cardData, classes, inquiryData } = this.props;
    return (
      <Col span={4} className={classes.iconToolbar}>
        {inquiryData.showInquiryComments && (
          <CommentCount
          prefetchedCount={cardData.commentCount}
            isLoading={this.props.isLoading}
            commentApiPrefix={'inquiry/bid'}
            className={classes.cardIcon}
            sourceObjectId={cardData.baseRevisionBidId}
            modalHeader={this.renderCommentModalHeader()}
          />
        )}
        {this.renderIcon()}
        <br />
        {this.renderDownloadTnCdocs()}
      </Col>
    );
  };

  renderDomesticCol2 = () => {
    const { cardData, classes, domesticVehicleTypeSizeList } = this.props;
    const { isVehicleDetailsExpanded } = this.state;
    return (
      <Col span={7}>
        <Row>
          {(<Col span={10} className={classes.cardHeaderItemsStyle}>
            {cardData.mode !== InquiryModes.RPTL ? 'Vehicle Details' : 'Packaging Details' }
          </Col>)}
          <Col span={14} className={classes.domesticInfo}>
            {getTrailerOrDomesticVehicleList(
              cardData,
              domesticVehicleTypeSizeList,
              isVehicleDetailsExpanded,
              this.handleVehicleListExpand,
              true
            )}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Weekly Schedule
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {['S', 'M', 'T', 'W', 'Th', 'F', 'Sa'].map((day) => {
              const isValid = cardData?.otherDetails?.schedule?.includes(day?.toLowerCase());
              return (
                <span
                  style={{
                    fontWeight: tokens.fontWeight.semibold,
                    color: isValid ? tokens.colors.text : '#CCCCCC',
                    marginRight: '8px',
                    fontSize: `${tokens.fontSize.small}px`,
                  }}
                >
                  {day}
                </span>
              );
            })}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            ETD
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDateValue(cardData?.otherDetails?.etd)?.format('DD MMM YYYY') || '-'}
          </Col>
        </Row>
      </Col>
    );
  };

  renderDomesticCol3 = () => {
    const { cardData, classes, currency, timezone } = this.props;
    const { freightCharges, originCharges, destinationCharges } = cardData?.chargeDetails;
    const isExchangeDatePresent = cardData?.exchangeRateDate;
    return (
      <Col span={6}>
        <Row>
          <Col span={12} className={classes.cardHeaderItemsStyle}>
            Transport Charges
          </Col>
          <Col span={12} className={classes.domesticInfo}>
          {this.getDomesticCharges(freightCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={12} className={classes.cardHeaderItemsStyle}>
            Origin Charges
          </Col>
          <Col span={12} className={classes.domesticInfo}>
          {this.getDomesticCharges(originCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={12} className={classes.cardHeaderItemsStyle}>
            Destination Charges
          </Col>
          <Col span={12} className={classes.domesticInfo}>
            {this.getDomesticCharges(destinationCharges, isExchangeDatePresent)}
          </Col>
        </Row>
        <Row className={classes.domensticBidInfoRow}>
          <Col span={12} className={classes.cardHeaderItemsStyle}>
            Bid Valid Till
          </Col>
          <Col span={12} className={classes.domesticInfo}>
            {momentTimezone(cardData?.validTill).tz(timezone).format('D MMM YYYY')}
          </Col>
        </Row>
      </Col>
    );
  };

  renderCommentModalHeader = () => {
    const { cardData, currency } = this.props;
    const amount = cardData.ffTotalWithoutTax && cardData.ffTotalWithoutTax.amount;
    const perLabel = cardData.totalPerUnit && cardData.totalPerUnit.format;
    const currencySymbol = cardData?.ffTotalWithoutTax?.currency;
    return (
      <Row
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Col
          span={6}
          style={{
            fontSize: `${tokens.fontSize.h2}px`,
            fontWeight: tokens.fontWeight.semibold,
            color: '#262626',
            alignSelf: 'center',
            marginLeft: '15px',
          }}
        >
          {cardData.ffName}
        </Col>
        <Col
          span={18}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '30px',
          }}
        >
          <div style={{ marginTop: '8px', marginRight: '68px' }}>
            <img src={cardData.shippingLineLogoUrl} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            {this.priceTotal(true, amount, currencySymbol)}
            {/* {InquiryModes.DOMESTIC ? (
              ''
            ) : (
              <PricePerContainer
                commentTextStyle={true}
                amount={cardData.totalPerUnit && cardData.totalPerUnit.amount}
                currency={cardData.totalPerUnit && cardData.totalPerUnit.currency}
                perLabel={perLabel}
                containerTypes={cardData.totalPerUnitType}
                totalPrice={cardData.ffTotalWithoutTax}
                mode={cardData.mode}
                sourceObjectType={'BID'}
              />
            )} */}
          </div>
        </Col>
      </Row>
    );
  };

  renderVersion = () => {
    const { cardData, classes } = this.props;
    return (
      <div className={classes.renderVersionContainer}>
        {cardData.revisionNumber > 0 && (
          <div>
            <Tag color="cyan">Revised Bid</Tag>
            <span className={classes.versionHistoryButton} onClick={this.showVersionHistory}>
              Version History
            </span>
            {this.renderModal()}
          </div>
        )}
      </div>
    );
  };

  renderRadio = () => {
    const { isChecked, onCheck, isAddBidCard } = this.props;
    if (!isAddBidCard) {
      return null;
    }
    return (
      <Col span={1}>
        <span style={{ cursor: 'pointer' }} onClick={onCheck}>
          <Radio checked={isChecked} />
        </span>
      </Col>
    );
  };

  showGapRank = () => {
    const { showGapForRank1, cardData, showGapForRank1AllBid, rank1BidInfo } = this.props;
    if (
      cardData.rank &&
      ((cardData.rank === '2' && showGapForRank1) ||
        (cardData.rank !== '1' && showGapForRank1AllBid)) &&
      rank1BidInfo
    )
      return true;

    return false;
  };

  renderConfirmationReason = () => {
    const { cardData, classes } = this.props;
    const { rank, isConfirmed, nonL1ConfirmationReason } = cardData;
    
    // Only show if rank is not 1, bid is confirmed, and reason exists
    if (Number(rank) === 1 || !isConfirmed || !nonL1ConfirmationReason) {
      return null;
    }

    return (
      <Tooltip title={nonL1ConfirmationReason} placement="top">
        <Button
          size="small"
          type="dashed"
          className={classNames(classes.rank1GapLabel, classes.confirmationReasonButton)}
          aria-label={`Confirmation Reason: ${nonL1ConfirmationReason}`}
        >
          <Icon type="check-circle" theme="filled" className={classes.confirmationReasonIcon} />
          <span className={classes.confirmationReasonText}>
            <strong>Confirmation Reason: </strong>{nonL1ConfirmationReason}
          </span>
        </Button>
      </Tooltip>
    );
  };

  showRankRemarks = () => {
    const { classes, cardData, rank1BidInfo } = this.props;
    const isRankGap = this.showGapRank();
    const isOtherOrgL1RankExists = cardData?.otherVendorsL1BidsExists;
    if (!isRankGap && !isOtherOrgL1RankExists) {
      return;
    }
    const amountDiff = isRankGap
      ? `${rank1BidInfo.currency} ${(
          cardData.totalPerUnit.amount - rank1BidInfo.amount || 0
        ).toFixed(2)}`
      : 0;
    let iconType = 'info-circle';
    let bgColor = '#fffdf4';
    let borderColor = '#F2BF5F';
    let iconColor = '#F8C146';
    let rankRemark = <div></div>;
    
    if (isRankGap) {
      rankRemark = <> Lower rates by <strong>{amountDiff}</strong> {rank1BidInfo.unit} to become <strong>Rank 1</strong>.</>;
    }
    if (isOtherOrgL1RankExists) {
      iconType = 'exclamation-circle';
      bgColor = '#fff4f4';
      borderColor = '#e91e63';
      iconColor = '#e91e63';
      rankRemark = <><strong> Important: </strong> Other bidders have bids with the <strong>same rank</strong>. Adjust your bid to stand out.</>;
    }

    return (
      <Button
        size="small"
        type="dashed"
        className={classes.rank1GapLabel}
        style={{
          borderColor: borderColor,
          fontSize: tokens.fontSize.caption,
          backgroundColor: bgColor,
          cursor: '',
          marginRight: '5px'
        }}
      >
        <Icon type={iconType} theme="filled" style={{ color: iconColor }} />
        {rankRemark}
      </Button>
    );
  }

  render() {
    const { classes, cardData, isAddBidCard, rank1BidInfo } = this.props;
    if (!cardData) return;
    return (
      <div
        className={
          this.props.cardData.isDeletedByShipper ? classNames(classes.deletedBidParentDiv, classes.parentDiv) : classes.parentDiv
        }
      >
        <div>
          <Row>
            {this.renderRadio()}
            {this.renderCol1()}
            {this.renderCol2()}
            {this.renderCol3()}
            {this.renderCol4()}
          </Row>
          <Row>
            <div className={classes.btmRowContainer}>
              <div className={classes.btmRowLeftSection}>
                {this.showRankRemarks()}
                {this.renderConfirmationReason()}
                {this.renderVersion()}
              </div>
              {!isAddBidCard && (
                <div className={classes.updatedTimeContainer}>{this.renderUpdatedTime()}</div>
              )}
            </div>
          </Row>
        </div>
        {
          this.state.extendDeadlineVisible &&
          <ExtendBidDeadline
            cardData={this.props.cardData}
            handleCancel={(shouldReload) => this.handleExtendDeadline(false, shouldReload)}
            visible={this.state.extendDeadlineVisible}
            timezone={this.props.timezone}
          />
        }
      </div>
    );
  }
}
const mapStateToProps = ({ masterData, inquiryReducer }) => ({
  currency: masterData.currencySymbols,
  permission: masterData.permissions.INQUIRY_BIDDING_ALL_ACTIONS,
  showGapForRank1AllBid: masterData.modules.show_gap_for_rank1_all_bids,
  showGapForRank1: inquiryReducer?.masterData?.showGapForRank1,
  domesticVehicleTypeSizeList: masterData.domesticVehicleTypeSizeList,
  timezone: masterData.timezone,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBidsFF,
      resetFilters,
      applyFilter,
    },
    dispatch
  );
const BidCardStyled = injectSheet(styles)(BidCard);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BidCardStyled));
